import { Playground } from 'docz';
import { Checkbox } from "../../../../../src/components/Form";
import * as React from 'react';
export default {
  Playground,
  Checkbox,
  React
};